import { Clear } from "@mui/icons-material";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ErpChip from "./ErpChip";

const estiloOpcao = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  width: "100%",
  minWidth: 0, // deixa o nome encolher dentro do select
};

// Nome longo encolhe com reticências; o selo do ERP nunca é cortado.
const estiloNome = {
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

// Filtro por ERP de origem, no mesmo formato do filtro de tipo de pessoa
// (components/tipoCliente/TipoClienteFilter): Select com o selo do ERP na
// opção e no valor escolhido.
//
// `erps`: [{ id, nome, tipo }] (ERPs cadastrados). `value`: id do ERP ou null.
// `limpavel={false}`: sem o botão de limpar (seleção obrigatória).
export default function ErpFilter({
  erps = [],
  value = null,
  onChange = () => {},
  label = "ERP",
  id = "filtro-erp",
  sx = {},
  limpavel = true,
}) {
  const opcaoDe = (erpId) => erps.find((erp) => erp.id === erpId);

  const conteudo = (erp) => (
    <Box sx={estiloOpcao}>
      <Box component="span" sx={estiloNome} title={erp.nome}>
        {erp.nome}
      </Box>
      <ErpChip erp={erp} sx={{ flexShrink: 0 }} />
    </Box>
  );

  return (
    <FormControl variant="outlined" size="small" sx={sx}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        label={label}
        value={value && opcaoDe(value) ? value : ""}
        onChange={(event) => onChange(event.target.value || null)}
        renderValue={(selecionado) => {
          const erp = opcaoDe(selecionado);
          return erp ? conteudo(erp) : "";
        }}
        endAdornment={
          value && limpavel ? (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <IconButton
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  onChange(null);
                }}
              >
                <Clear fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      >
        {erps.map((erp) => (
          <MenuItem key={erp.id} value={erp.id}>
            {conteudo(erp)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
